export default __webpack_public_path__ + "media/images/admin-hover-right-db34a19c0e2453c125af7faf1fb835b5.png";